import { motion } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        padding-top: 0;
    }
`;

export const ModalWrapper = styled.div`
    max-width: 35rem;
    width: calc(100% - 1rem);
    height: fit-content;

    overflow-y: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10000;
    border-radius: 0.625rem;
    padding: 1rem;

    display: flex;
    flex-direction: column;

    p {
        font-weight: 600;
        padding-bottom: 1rem;
        font-size: 1.25rem;
    }
`;

export const ModalTitleClose = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;

    p {
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.5rem;
        color: ${({ theme }) => theme.colors['neutral-900']};
    }
`;

export const ModalContent = styled.div`
    color: ${({ theme }) => theme.colors['neutral-900']};

    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;

    p {
        margin-bottom: 1rem;
    }
`;

export const CloseModalButton = styled(LuX)`
    cursor: pointer;
    position: absolute;
    top: 1.25rem; // 20px / 16
    right: 1.25rem; // 20px / 16
    width: 1.25rem;
    height: 1.25rem;
    padding: 0;
    z-index: 10;
    z-index: 10001;
`;

export const WrapModal = styled.div`
    width: 25rem;
`;

export const RemovingElementWrap = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: start;
    gap: 1.5rem;

    flex-direction: column;

    span {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.colors['neutral-950']};
        line-height: 1.2rem;
        font-weight: 400;
    }
`;

export const ButtonsWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;

    gap: 0.75rem;
`;
